module.exports = __webpack_public_path__ + "media/fresh blood.e811fa25.wav";